import * as Common from '@/tenant/common';

export class SalesAnalyseReportQuery extends Common.Query {
    constructor(){
        super("SalesAnalyseReportQuery", null);
    }
    public templateId:number=0;
    public year: number = null;
    public month: number = null;
    public period: number = null;
    public segment: Common.Segment = null;
    public counterpart: Common.Counterpart = null;
    public counterpartCategory: Common.Category = null;
    public commodity: Common.Commodity = null;
    public commodityCategory: Common.Category = null;
    public itemCategory: number = null;
    public summaryCategory1: number = null;
    public summaryCategory2: number = null;
    // public includeProspect: boolean = false;
    public onExcelExport:boolean = false;    
    public searchDeliveryDate: boolean = false;
    public includeProspectType: Common.IncludeProspectTypes = Common.IncludeProspectTypes.None;
}

export class SalesAnalyseReportTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='SalesAnalyseReportQuery';
  sort = 'id';
  constructor() {
    super();
  }
}

export enum PeriodTypes {
  FirstPeriod = 0,
  SecondPeriod = 1,
}